import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import STooltip from "../../../Tooltip";
import { SIcon, SIconType } from "../../../components";
import { LocalizationPill, LocalizedTextBox } from "./LocalizationPill";
export const LocalizationPickerRow = ({ item })=>{
    const keyName = item?.state?.props?.files.find((x)=>true)?.keyName;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-row justify-between items-center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-start justify-start gap-1 -ml-1",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col items-start justify-start gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(LocalizationPill, {
                                children: keyName || item.state?.props?.keyId
                            }),
                            item?.state?.props.text.value && /*#__PURE__*/ _jsx(LocalizedTextBox, {
                                children: item?.state?.props.text.value
                            })
                        ]
                    }),
                    item.state?.description && /*#__PURE__*/ _jsx("div", {
                        className: "pt-1 text-xs opacity-50 overflow-ellipsis",
                        children: item.state?.description
                    })
                ]
            }),
            item.state?.props?.isDeleted && /*#__PURE__*/ _jsx(STooltip, {
                content: /*#__PURE__*/ _jsx("p", {
                    children: "This key has been deleted"
                }),
                children: /*#__PURE__*/ _jsx(SIcon, {
                    type: SIconType.WarningTriangle,
                    size: 13,
                    className: "text-orange-400"
                })
            })
        ]
    });
};
